export default "__VITE_ASSET__Cg1qGWoj__"